/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AltaMedicoModelDto } from '../../models/alta-medico-model-dto';

export interface MedicosControllerEditarMedico$Params {

/**
 * UUID del médico a editar
 */
  uuidMedico: string;
  
    /**
     * Datos del médico a editar
     */
    body: AltaMedicoModelDto
}

export function medicosControllerEditarMedico(http: HttpClient, rootUrl: string, params: MedicosControllerEditarMedico$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, medicosControllerEditarMedico.PATH, 'put');
  if (params) {
    rb.path('uuidMedico', params.uuidMedico, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

medicosControllerEditarMedico.PATH = '/api/medicos/editar-medico/{uuidMedico}';
